var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClearIconX(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.24995 5.5L10.6376 2.11238C11.1208 1.62914 11.1208 0.845668 10.6376 0.362429C10.1543 -0.12081 9.37089 -0.12081 8.88762 0.362429L5.5 3.75005L2.11238 0.362429C1.62914 -0.12081 0.845668 -0.12081 0.362429 0.362429C-0.12081 0.845668 -0.12081 1.62914 0.362429 2.11238L3.75005 5.5L0.362429 8.88762C-0.12081 9.37086 -0.12081 10.1543 0.362429 10.6376C0.604049 10.8792 0.92072 11 1.23739 11C1.55406 11 1.87076 10.8792 2.11235 10.6376L5.5 7.24995L8.88762 10.6376C9.12924 10.8792 9.44591 11 9.76258 11C10.0793 11 10.3959 10.8792 10.6375 10.6376C11.1208 10.1543 11.1208 9.37086 10.6375 8.88762L7.24995 5.5Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearIconX);
export default __webpack_public_path__ + "static/media/clearIconX.b1c8e20e07d60a363a6debe4c786830d.svg";
export { ForwardRef as ReactComponent };